import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const generateSchema = params => api.request(3, '/generate-schema/', MethodType.POST, params)

export const fetchGenbiEntity = (profileName, params) => api.request(3, `/entity/${profileName}`, MethodType.GET, params)

export const addGenbiEntity = (profileName, params) => api.request(3, `/entity/${profileName}`, MethodType.POST, params)

export const delGenbiEntity = (profileName, id, params) => api.request(3, `/entity/${profileName}/${id}`, MethodType.DELETE, params)

// GenBI Subscription APIs
export const fetchGenBiSubscription = params => api.request(1, '/genBi/subscription', MethodType.GET, params)

export const consumeGenBiQuota = params => api.request(1, '/genBi/subscription/consume', MethodType.POST, params)

export const setGenBiQuota = params => api.request(1, '/genBi/subscription', MethodType.POST, params)
